import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { endPoints } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirmaActaEppService {
  private apiUrl = `${endPoints.FirmaActaEppService}`;

  constructor(private http: HttpClient) { }

  obtenerActa(token: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${encodeURIComponent(token)}`);
  }

  firmar(token: string, firma: string): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}${encodeURIComponent(token)}`, { firma });
  }
}
